module.exports = __webpack_public_path__ + "static/media/close.7f5ab3e9.svg";